
























import {Component, Vue} from 'vue-property-decorator';
import QRCode from 'qrcode'

@Component({})
export default class ThemesModal extends Vue {

  mounted() {
    const themesUrl = 'https://rhizom.film/themenpfade'
    QRCode.toCanvas(this.$refs['qr-canvas'], themesUrl, {
      margin: 0.5,
      color: {
        dark: '#00000000',
        light: '#FFFFFFFF'
      }
    }, (err) => {
      if (err) {
        console.error(err)
        return
      }
    })
  }

  close() {
    this.$store.dispatch('rhizome/closeThemesModal')
  }
}
